import { render } from "./SimplePerfData.vue?vue&type=template&id=48c3b6b6&scoped=true&ts=true"
import script from "./SimplePerfData.vue?vue&type=script&lang=ts"
export * from "./SimplePerfData.vue?vue&type=script&lang=ts"

import "./SimplePerfData.vue?vue&type=style&index=0&id=48c3b6b6&scoped=true&lang=css"
import "./SimplePerfData.vue?vue&type=style&index=1&id=48c3b6b6&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c3b6b6"]])

export default __exports__